// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.horizontal_Br4es.row_qBg1u {
  display : -webkit-inline-box;
  display : -ms-inline-flexbox;
  display : inline-flex;
  -webkit-box-orient : vertical;
  -webkit-box-direction : normal;
      -ms-flex-direction : column;
          flex-direction : column;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.horizontal_Br4es.row_qBg1u.reverse_Vubcn { 
  -webkit-box-orient : vertical; 
  -webkit-box-direction : reverse; 
      -ms-flex-direction : column-reverse; 
          flex-direction : column-reverse;
}
.horizontal_Br4es {
  display : -webkit-box;
  display : -ms-flexbox;
  display : flex;
  -webkit-box-orient : horizontal;
  -webkit-box-direction : normal;
      -ms-flex-direction : row;
          flex-direction : row;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.vertical_iSxC6.row_qBg1u {
  display : -webkit-box;
  display : -ms-flexbox;
  display : flex;
  -webkit-box-orient : horizontal;
  -webkit-box-direction : normal;
      -ms-flex-direction : row;
          flex-direction : row;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

.vertical_iSxC6.row_qBg1u.reverse_Vubcn { 
  -webkit-box-orient : horizontal; 
  -webkit-box-direction : reverse; 
      -ms-flex-direction : row-reverse; 
          flex-direction : row-reverse;
}

.vertical_iSxC6 {
  display : -webkit-box;
  display : -ms-flexbox;
  display : flex;
  -webkit-box-orient : vertical;
  -webkit-box-direction : normal;
      -ms-flex-direction : column;
          flex-direction : column;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  -webkit-box-align: stretch;
      -ms-flex-align: stretch;
          align-items: stretch; 
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/DataBlock.css"],"names":[],"mappings":"AAAA;EACE,4BAAqB;EAArB,4BAAqB;EAArB,qBAAqB;EACrB,6BAAuB;EAAvB,8BAAuB;MAAvB,2BAAuB;UAAvB,uBAAuB;EACvB,uBAA2B;MAA3B,oBAA2B;UAA3B,2BAA2B;EAC3B,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,6BAA+B;EAA/B,+BAA+B;MAA/B,mCAA+B;UAA/B,+BAA+B;AACjC;AACA;EACE,qBAAc;EAAd,qBAAc;EAAd,cAAc;EACd,+BAAoB;EAApB,8BAAoB;MAApB,wBAAoB;UAApB,oBAAoB;EACpB,uBAA2B;MAA3B,oBAA2B;UAA3B,2BAA2B;EAC3B,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE,qBAAc;EAAd,qBAAc;EAAd,cAAc;EACd,+BAAoB;EAApB,8BAAoB;MAApB,wBAAoB;UAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,+BAA4B;EAA5B,+BAA4B;MAA5B,gCAA4B;UAA5B,4BAA4B;AAC9B;;AAEA;EACE,qBAAc;EAAd,qBAAc;EAAd,cAAc;EACd,6BAAuB;EAAvB,8BAAuB;MAAvB,2BAAuB;UAAvB,uBAAuB;EACvB,uBAA2B;MAA3B,oBAA2B;UAA3B,2BAA2B;EAC3B,0BAAoB;MAApB,uBAAoB;UAApB,oBAAoB;AACtB","sourcesContent":[".horizontal.row {\n  display : inline-flex;\n  flex-direction : column;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.horizontal.row.reverse { \n  flex-direction : column-reverse;\n}\n.horizontal {\n  display : flex;\n  flex-direction : row;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n\n.vertical.row {\n  display : flex;\n  flex-direction : row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.vertical.row.reverse { \n  flex-direction : row-reverse;\n}\n\n.vertical {\n  display : flex;\n  flex-direction : column;\n  justify-content: flex-start;\n  align-items: stretch; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"horizontal": `horizontal_Br4es`,
	"row": `row_qBg1u`,
	"reverse": `reverse_Vubcn`,
	"vertical": `vertical_iSxC6`
};
export default ___CSS_LOADER_EXPORT___;
